import api from '@/lib/api'
import type { APIErrorResponse } from '@/types/errors'
import { extractAPIError } from '@/lib/error-utils'

export type Result<T, E = APIErrorResponse> =
  | { success: true; data: T }
  | { success: false; error: E }

export interface CreateSupportTicketRequest {
  subject: string
  message: string
  category?: string
}

export interface CreateSupportTicketResponse {
  ticket_id: string
  status: string
}

export const supportService = {
  /**
   * Create a support ticket for the signed-in user.
   * The backend forwards it to the Brazilnut support desk.
   */
  async createTicket(
    request: CreateSupportTicketRequest
  ): Promise<Result<CreateSupportTicketResponse>> {
    try {
      const { data } = await api.post<CreateSupportTicketResponse>(
        '/support/tickets',
        request
      )
      return { success: true, data }
    } catch (error) {
      const apiError = extractAPIError(error)
      return {
        success: false,
        error: apiError || { error_code: 'UNKNOWN_ERROR', message: String(error) },
      }
    }
  },
}
